import { render, staticRenderFns } from "./MessageTypeAutoReply.vue?vue&type=template&id=7f10f94c&scoped=true&"
import script from "./MessageTypeAutoReply.vue?vue&type=script&lang=js&"
export * from "./MessageTypeAutoReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10f94c",
  null
  
)

export default component.exports